import { render, staticRenderFns } from "./TotemPanel.vue?vue&type=template&id=4c9be565&scoped=true"
import script from "./TotemPanel.vue?vue&type=script&lang=js"
export * from "./TotemPanel.vue?vue&type=script&lang=js"
import style0 from "./TotemPanel.vue?vue&type=style&index=0&id=4c9be565&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9be565",
  null
  
)

export default component.exports